module.exports = __webpack_public_path__ + "static/actionable-insights-42ae4e7ed35d81ef1c1ada37816fc871.svg";